export const DefaultStaleTime = 3600000;
